(function () {
  'use strict';

  function debounce(fn, delay) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, delay);
    };
  }

  function initAuteurSearch(input) {
    if (input.dataset.auteurSearchInit) return;
    input.dataset.auteurSearchInit = '1';

    // Liste DOM existante (pour filtrage local — fallback / page recherche)
    var fieldset = input.closest('fieldset');
    var domList = fieldset && fieldset.querySelector('ul');
    function getDomItems() {
      return domList ? Array.prototype.slice.call(domList.querySelectorAll('li')) : [];
    }
    function getDomItemText(li) {
      var label = li.querySelector('label');
      if (!label) return '';
      var clone = label.cloneNode(true);
      var svgs = clone.querySelectorAll('svg');
      for (var i = 0; i < svgs.length; i++) svgs[i].remove();
      return clone.textContent.trim().toLowerCase();
    }
    function filterDomItems(q) {
      getDomItems().forEach(function (li) {
        if (q) {
          var match = getDomItemText(li).indexOf(q) !== -1;
          if (match) {
            if (li.classList.contains('hidden')) {
              li.dataset.wasHidden = '1';
              li.classList.remove('hidden');
            }
            li.style.display = '';
          } else {
            li.style.display = 'none';
          }
        } else {
          if (li.dataset.wasHidden) {
            li.classList.add('hidden');
            delete li.dataset.wasHidden;
          }
          li.style.display = '';
        }
      });
    }

    // Dropdown
    var dropdown = document.createElement('ul');
    dropdown.className = 'facet-auteur-results';
    dropdown.style.display = 'none';
    input.parentNode.insertBefore(dropdown, input.nextSibling);

    function hideDropdown() {
      dropdown.innerHTML = '';
      dropdown.style.display = 'none';
    }

    function applyFilter(authorKey) {
      var form = document.querySelector('#FacetFiltersForm');
      if (!form) return;

      var target;
      var existing = form.querySelector('input[name="fk_auteur"][value="' + authorKey + '"]');
      if (existing) {
        existing.checked = true;
        target = existing;
      } else {
        var hidden = document.createElement('input');
        hidden.type = 'checkbox';
        hidden.name = 'fk_auteur';
        hidden.value = authorKey;
        hidden.checked = true;
        hidden.style.display = 'none';
        form.appendChild(hidden);
        target = hidden;
      }
      target.dispatchEvent(new Event('input', { bubbles: true }));
    }

    function showResults(auteurs) {
      dropdown.innerHTML = '';
      if (!auteurs || auteurs.length === 0) {
        var empty = document.createElement('li');
        empty.className = 'facet-auteur-results__empty';
        empty.textContent = 'Aucun résultat';
        dropdown.appendChild(empty);
      } else {
        auteurs.forEach(function (a) {
          var li = document.createElement('li');
          li.className = 'facet-auteur-results__item';
          li.innerHTML = '<span class="facet-auteur-results__name">' + a.libelle + '</span>' +
            (a.qte ? '<span class="facet-auteur-results__count">(' + a.qte + ')</span>' : '');
          li.addEventListener('mousedown', function (e) {
            e.preventDefault();
            applyFilter(a.key);
            hideDropdown();
            input.value = '';
          });
          dropdown.appendChild(li);
        });
      }
      dropdown.style.display = 'block';
    }

    var doSearch = debounce(function (q) {
      var params = bhmoteur && bhmoteur.getParams();
      if (!params || !params.url) return;

      $.ajax({
        url: params.url,
        type: 'POST',
        data: {
          q: q,
          limit: 1,
          from: 0,
          return_aggregations: true,
          is_collection: true,
          collection: params.filter_m_id_collection,
          debug: false
        },
        success: function (d) {
          var agg = d.result && d.result.aggregations;
          if (!agg) { hideDropdown(); return; }
          var auteurAgg;
          for (var i = 0; i < agg.length; i++) {
            if (agg[i].key === 'fk_auteur') { auteurAgg = agg[i]; break; }
          }
          if (!auteurAgg || !auteurAgg.data || auteurAgg.data.length === 0) {
            hideDropdown(); return;
          }
          showResults(auteurAgg.data);
        },
        error: function () { hideDropdown(); }
      });
    }, 300);

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); e.stopPropagation(); }
      if (e.key === 'Escape') { hideDropdown(); input.value = ''; filterDomItems(''); }
    });

    input.addEventListener('input', function (e) {
      e.stopPropagation();
      e.stopImmediatePropagation();
      var q = this.value.trim();
      if (!q || q.length < 2) { hideDropdown(); filterDomItems(''); return; }
      filterDomItems(q.toLowerCase());
      doSearch(q);
    });

    input.addEventListener('blur', function () {
      setTimeout(hideDropdown, 150);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-facet-auteur-search]').forEach(initAuteurSearch);
  }

  var observer = new MutationObserver(initAll);
  observer.observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState !== 'loading') {
    initAll();
  } else {
    document.addEventListener('DOMContentLoaded', initAll);
  }
})();
